import { useCallback, useSyncExternalStore } from 'react';

import telemetryStore from '@/stores/telemetryStore';

const useRobotTelemetry = (robotId, msgId) => {
  const key = `${robotId}:${msgId}`;
  const subscribe = useCallback((listener) => telemetryStore.subscribe(key, listener), [key]);

  return useSyncExternalStore(subscribe, () => telemetryStore.get(robotId, msgId));
};

export default useRobotTelemetry;
